<h1 mat-dialog-title *ngIf="displayTimer">Session Timeout</h1>
<div mat-dialog-content *ngIf="displayTimer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h4>
          Session will expire in <strong style="color: red">{{ displayTimer }} Seconds</strong>
        </h4>
        <p>Click "Resume Session" to "Continue" or "Logout" to end the session</p>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions *ngIf="displayTimer">
  <button
    role="button"
    type="button"
    aria-label="Resume"
    class="btn btn-primary"
    cdkFocusInitial
    style="margin-right: 2%"
    (click)="resume()"
  >
    Resume session
  </button>
  <button
    role="button"
    type="button"
    aria-label="Logout"
    class="btn btn-secondary"
    (click)="logout()"
  >
    Logout
  </button>
</div>
